import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import PrivacyPolicyModal from '../src/components/modals/PrivacyPolicyModal';
import { colors } from '../src/styles/theme';

export default function PrivacyRoute() {
  const router = useRouter();

  const handleDismiss = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace('/');
    }
  };

  return (
    <View style={styles.container}>
      <PrivacyPolicyModal
        visible={true}
        onClose={handleDismiss}
        onBack={handleDismiss}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
});
